import React from "react";
import "../App.css";

const FAQ_ITEMS = [
  {
    question: "Como funciona a troca de contador?",
    answer:
      "O processo é simples e seguro, sem interrupção das suas atividades. Cuidamos de toda a transição documental e fiscal.",
  },
  {
    question: "Quais documentos são necessários para abrir uma empresa?",
    answer:
      "Após um diagnóstico inicial, orientaremos sobre toda a documentação legal e fiscal necessária, simplificando cada etapa.",
  },
  {
    question: "Como solicitar uma proposta?",
    answer:
      "Preencha o formulário nesta página ou entre em contato direto. Faremos um diagnóstico para apresentar a solução ideal para sua empresa.",
  },
];

export default function Faq() {
  return (
    <section className="faq">
      <div className="faq__container">
        <span className="faq__eyebrow">Dúvidas Frequentes</span>
        <h2 className="faq__title">Respostas para suas principais perguntas</h2>

        <div className="faq__grid">
          {FAQ_ITEMS.map((item) => (
            <div key={item.question} className="faq__card">
              <h3 className="faq__question">{item.question}</h3>
              <p className="faq__answer">{item.answer}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
